/* eslint-disable import/prefer-default-export */
export const removeHtml = value => value?.replace(/<\/?[^>]+(>|$)/g, '');
